import axiosInstance from "./axiosInstance";

export function create(param) {
  return axiosInstance.post('leaveMassage/add',param)
}

export function update(param) {
  return axiosInstance.post('leaveMassage/edit',param)
}

export function del(param) {
	return axiosInstance.post('leaveMassage/del', param)
}

export function query(param) {
  return axiosInstance.post('leaveMassage/query',param)
}

export function upload(formData) {
	return axiosInstance.post('file/obsUploadFile', formData)
}

export function queryLeaveMassage(param) {
  return axiosInstance.post('leaveMassage/query',param)
}